import React from 'react';
import PushNotificationButton from '../components/PushNotificationButton';

const Settings = () => {
  return (
    <div>
      <h2>📢 Push-Benachrichtigungen</h2>
      <p>Melde dich für Live-Ticker Benachrichtigungen an!</p>
      <PushNotificationButton />
    </div>
  );
};

export default Settings;
